import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {provideRouter} from '@angular/router';

import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {environment} from 'src/environments/environment';
import {routes} from './app.routes';
import {JwtInterceptor} from './auth/jwt.interceptor';
import {provideAnimations} from '@angular/platform-browser/animations';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([JwtInterceptor])),
    provideAnimations(),
    provideTranslateService(),
    ...provideTranslateHttpLoader({
      prefix: environment.host + '/assets/i18n/',
      suffix: '.json',
    }),
  ],
};
